import * as api from '@/api/give-course/interact'
import * as TYPES from './type';

export default {
  //举手
  async getSKInteractList({ commit, state }, { paramets, cb }) {
    const result = await api.reqSKInteractList(paramets)
    commit(TYPES.SK_INTERACT_LIST, { result })
    cb && cb()
  },
  //举手添加
  async postSKInteractAdd({ commit, state }, { paramets, cb }) {
    const result = await api.reqSKInteractAdd(paramets)
    commit(TYPES.SK_INTERACT_ADD, { result })
    cb && cb()
  },
  //举手查询
  async getSKInteractQuery({ commit, state }, { paramets, cb }) {
    const result = await api.reqSKInteractQuery(paramets)
    commit(TYPES.SK_INTERACT_QUERY, { result })
    cb && cb()
  },
  //举手结束
  async getSKInteractOver({ commit, state }, { paramets, cb }) {
    const result = await api.reqSKInteractOver(paramets)
    commit(TYPES.SK_INTERACT_OVER, { result })
    cb && cb()
  },
  //举手结果
  async getSKInteractRes({ commit, state }, { paramets, cb }) {
    const result = await api.reqSKInteractRes(paramets)
    commit(TYPES.SK_INTERACT_RES, { result })
    cb && cb()
  },
  //举手编辑
  async putSKInteractEdit({ commit, state }, { paramets, cb }) {
    const result = await api.reqSKInteractEdit(paramets)
    commit(TYPES.SK_INTERACT_EDIT, { result })
    cb && cb()
  },
}



// WEBPACK FOOTER //
// ./src/store/give-course/interact/actions.js